module.exports = __webpack_public_path__ + "static/media/checked-icon.b6e422c1.svg";